import cn from 'client/utils/cn';

import React from 'react';

import { SvgIconId } from 'client/bundles/types';

import { getIcon } from './helpers';

import './index.css';

const b = cn('icon');

interface Props {
    icon: SvgIconId;
    mix?: string;
}

const SvgIcon = ({ icon, mix }: Props) => {
    const CurenIcon = getIcon(icon);

    if (!CurenIcon) {
        return null;
    }

    return (
        <i className={b('', [mix])}>
            <CurenIcon />
        </i>
    );
};

export default SvgIcon;
